import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.805 12.472a.667.667 0 0 0 0-.943L8.276 8l3.529-3.528a.667.667 0 0 0-.943-.943l-4 4a.667.667 0 0 0 0 .943l4 4c.26.26.682.26.943 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 3.334c.368 0 .667.298.667.666v8a.667.667 0 0 1-1.334 0V4c0-.368.299-.667.667-.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })